import React, { createContext, useContext, useState } from 'react';
const CartContext = createContext({ items: [], add: () => {}, remove: () => {} });
export const useCart = () => useContext(CartContext);
export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const add    = (item) => setItems(prev => [...prev, item]);
  const remove = (id)   => setItems(prev => prev.filter(i => i.id !== id));
  return <CartContext.Provider value={{ items, add, remove }}>{children}</CartContext.Provider>;
}
